import React, { useState, useEffect } from "react";
import {
  getFirestore,
  doc,
  setDoc,
  getDoc,
  onSnapshot,
} from "firebase/firestore";
import { Typography } from "@mui/material";
import CheckBoxIcon from "@material-ui/icons/CheckBox";
import ShortTextIcon from "@material-ui/icons/ShortText";
import SubjectIcon from "@material-ui/icons/Subject";
import FilterNoneIcon from "@material-ui/icons/FilterNone";
import AddCircleOutlineIcon from "@material-ui/icons/AddCircleOutline";
import CloseIcon from "@material-ui/icons/Close";
import Select from "@material-ui/core/Select";
import AccordionSummary from "@material-ui/core/AccordionSummary";
import AccordionDetails from "@material-ui/core/AccordionDetails";
import Button from "@material-ui/core/Button";
import Radio from "@material-ui/core/Radio";
import Accordion from "@material-ui/core/Accordion";
import ShareIcon from "@material-ui/icons/Share";
import {
  FormGroup,
  IconButton,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from "@material-ui/core";
import { BsTrash } from "react-icons/bs";
import { BsFileText } from "react-icons/bs";
import {
  BsClock,
  BsPeople,
  BsCameraVideo,
  BsEye,
  BsPersonBadge,
  BsGeoAlt,
} from "react-icons/bs";
import { FcRightUp } from "react-icons/fc";
import "./QuestionForm.css";
import MenuItem from "@material-ui/core/MenuItem";
import Switch from "@material-ui/core/Switch";
import Cookies from "js-cookie";
import { useNavigate, useParams } from "react-router-dom";

import SnackBar from "./SnackBar";
import Formheader from "./Formheader";
import { DashboardSidebar } from "./Header";
import Centeredtab from "./Tabs";
import AddIcon from "@mui/icons-material/Add";
import { getDatabase, onValue, ref, push, set } from "firebase/database";
import { app } from "../firebase";
import Userform from "./Userform";
import { questionHasAnswerKey } from "./grading";


// Reusable purple pill-toggle row used in the test settings card.
function ToggleRow({ icon, label, description, checked, onChange }) {
  return (
    <label className={`toggle-row ${checked ? "toggle-row-active" : ""}`}>
      <span className="toggle-row-icon">{icon}</span>

      <span className="toggle-row-text">
        <strong>{label}</strong>
        {description && <small>{description}</small>}
      </span>

      <span className="toggle-switch">
        <input
          type="checkbox"
          checked={checked}
          onChange={onChange}
        />

        <span className="toggle-switch-track">
          <span className="toggle-switch-thumb" />
        </span>
      </span>
    </label>
  );
}


function QuestionForm({ photoURL, value, i }) {
  const navigate = useNavigate();

  const [text, setText] = useState("");
  const [open, setOpen] = useState(false);
  const [color, setColor] = useState("success");
  const [isDraft, setIsDraft] = useState(false);

  const { id } = useParams();

  const [isAnonymous, setIsAnonymous] = useState(false);
  const [check, defaultCheck] = useState(true);
  const [draftData, setDraftData] = useState(null);

  const [formName, setFormName] = useState("");
  const [formDescription, setFormDescription] = useState("");
  const [percentage, setPercentage] = useState("");

  const [includeCamera, setIncludeCamera] = useState(true);

  // ============================================================
  // LOCATION FUNCTIONALITY LIFTED FROM SECOND QUESTIONFORM
  // ============================================================
  const [includeLocation, setIncludeLocation] = useState(true);

  const getUserLocation = () => {
    return new Promise((resolve) => {
      if (!navigator.geolocation) {
        console.warn("Geolocation is not supported by this browser.");
        resolve(null);
        return;
      }

      navigator.geolocation.getCurrentPosition(
        (position) => {
          resolve({
            latitude: position.coords.latitude,
            longitude: position.coords.longitude,
            accuracy: position.coords.accuracy,
          });
        },
        (error) => {
          console.warn("Unable to get user location:", error);
          resolve(null);
        },
        {
          enableHighAccuracy: true,
          timeout: 10000,
          maximumAge: 0,
        }
      );
    });
  };

  // Extract the unique id from the URL
  const uuid = window.location.pathname.split("/form/")[1];

  const [duplicateDialogOpen, setDuplicateDialogOpen] = useState(false);

  const [enableTimer, setEnableTimer] = useState(false);
  const [timerDuration, setTimerDuration] = useState(0);

  const [showResult, setShowResult] = useState(true);
  const [requireName, setRequireName] = useState(false);

  const [shareDialogOpen, setShareDialogOpen] = useState(false);
  const [publishedFormUrl, setPublishedFormUrl] = useState("");


  // ============================================================
  // TEST INSTRUCTIONS
  // ============================================================

  const instructionOptions = [
    {
      id: "read-carefully",
      title: "Read all questions carefully",
      text: "Make sure you understand each question before submitting your answer.",
    },
    {
      id: "complete-on-time",
      title: "Complete the test within the allotted time",
      text: "Submit your test before the timer expires.",
    },
    {
      id: "do-not-refresh",
      title: "Do not refresh the page",
      text: "Refreshing the page may interrupt your test or cause you to lose progress.",
    },
    {
      id: "do-not-switch-tabs",
      title: "Do not switch tabs or windows",
      text: "Stay on the test page while completing the assessment.",
    },
    {
      id: "fullscreen",
      title: "Stay in fullscreen mode",
      text: "Keep the test in fullscreen mode until you have submitted it.",
    },
    {
      id: "no-external-help",
      title: "Do not use external assistance",
      text: "Complete the assessment independently without using external websites or assistance.",
    },
    {
      id: "camera-required",
      title: "Camera must remain enabled",
      text: "Camera access is required while completing this test.",
    },
    {
      id: "location-required",
      title: "Location access is required",
      text: "Location permission is required before you can start the test.",
    },
  ];

  const [selectedInstructions, setSelectedInstructions] = useState([
    "read-carefully",
  ]);

  const [customInstructions, setCustomInstructions] = useState("");


  // ============================================================
  // SETTINGS HANDLERS
  // ============================================================

  const handleSwitchChange = () => {
    setIsAnonymous(!isAnonymous);
  };

  const handleCameraToggle = (event) => {
    setIncludeCamera(event.target.checked);
  };

  // LOCATION TOGGLE
  const handleLocationToggle = (event) => {
    setIncludeLocation(event.target.checked);
  };


  // ============================================================
  // QUESTIONS
  // ============================================================

const [questions, setQuestions] = useState([
  {
    questionText: "",
    questionType: "radio",
    options: [{ optionText: "" }],
    answer: false,
    answerKey: "", // matches questionType: "radio" (string, not array)
    points: 0,
    open: true,
    required: true,
  },
]);

  const [formInfo, setFormInfo] = useState({
    formName: "",
    formDescription: "",
    questions: [],
    percentage: "",
    timerDuration: "",
  });


  const handleClose = (event, reason) => {
    if (reason === "clickaway") {
      return;
    }

    setOpen(false);
  };


  const [defaultOption, setDefaultOption] = useState("Radio");

  const handleDefaultOptionChange = (event) => {
    setDefaultOption(event.target.value);
  };


  // ============================================================
  // SAVE CURRENT URL
  // ============================================================

  useEffect(() => {
    const currentURL = window.location.pathname;
    sessionStorage.setItem("currentURL", currentURL);
  }, []);


  const saveEmail = sessionStorage.getItem("email");


  // ============================================================
  // FORM DATA
  // ============================================================

  const [data, setData] = useState({
    formName: "",
    formDescription: "",
    questions: [],
    saveEmail,
    activate: true,
    percentage: "",
    timerDuration: "",
  });


  const url = window.location.pathname;


  const handleSwitchChange1 = (event) => {
    const newValue = event.target.checked;
    setEnableTimer(newValue);
  };


  const db = getFirestore(app);


  // ============================================================
  // CHECK IF FORM EXISTS
  // ============================================================

  const formExistsInDatabase = async (id) => {
    try {
      const docRef = doc(db, "forms", id);
      const docSnap = await getDoc(docRef);

      return docSnap.exists();
    } catch (error) {
      console.error(
        "Error checking if form exists in Firestore:",
        error
      );

      return false;
    }
  };


  // ============================================================
  // SAVE AS DRAFT
  // LOCATION FUNCTIONALITY FROM SECOND CODE
  // ============================================================

  const handleSaveAsDraft = async () => {
    try {
      // Get location only if Location setting is enabled
      const userLocation = includeLocation
        ? await getUserLocation()
        : null;

      const formData = {
        formName: data ? data.formName : formName,
        formDescription: data
          ? data.formDescription
          : formDescription,

        questions: data
          ? data.questions
          : questions,

        saveEmail,
        isAnonymous,
        activate: false,

        percentage: data
          ? data.percentage
          : percentage,

        enableTimer,

        timerDuration: data
          ? data.timerDuration
          : timerDuration,

        // LOCATION
        location: userLocation,
        includeLocation,

        includeCamera,

        showResult,
        requireName,

        selectedInstructions,
        customInstructions,
      };


      if (
        Object.values(formData).some(
          (value) => value === undefined
        )
      ) {
        console.error(
          "One or more properties in formData is undefined"
        );

        return;
      }


      const docRef = doc(db, "forms", id);

      await setDoc(docRef, formData);


      setColor("success");
      setOpen(true);
      setText("Form draft updated successfully.");

    } catch (error) {
      console.error("Error saving draft.", error);

      setColor("error");
      setText(
        "Failed to save the draft. Please try again later."
      );

      setOpen(true);
    }
  };


  // ============================================================
  // PUBLISH FORM
  // LOCATION FUNCTIONALITY FROM SECOND CODE
  // ============================================================

  const handleSendForm = async () => {
    try {
      // Get location only if Location setting is enabled
      const userLocation = includeLocation
        ? await getUserLocation()
        : null;


      const formData = {
        formName: data ? data.formName : formName,

        formDescription: data
          ? data.formDescription
          : formDescription,

        questions: data
          ? data.questions
          : questions,

        saveEmail,
        isAnonymous,

        activate: true,

        percentage: data
          ? data.percentage
          : percentage,

        enableTimer,

        timerDuration: data
          ? data.timerDuration
          : timerDuration,

        // LOCATION
        location: userLocation,
        includeLocation,

        includeCamera,

        showResult,
        requireName,

        selectedInstructions,
        customInstructions,
      };


      if (
        Object.values(formData).some(
          (value) => value === undefined
        )
      ) {
        console.error(
          "One or more properties in formData is undefined"
        );

        return;
      }


      const docRef = doc(db, "forms", id);

      await setDoc(docRef, formData);


      setColor("success");
      setOpen(true);

      setText(
        "Form is published successfully. You can now share it!"
      );


      const formUrl = `${window.location.origin}/form/${id}/instructions/userform`;


      setPublishedFormUrl(formUrl);

      sessionStorage.setItem(
        "publishedFormUrl",
        formUrl
      );

      sessionStorage.setItem(
        "publishedFormName",
        formData.formName
      );

    } catch (error) {
      console.error("Error sending form.", error);

      setColor("error");

      setText(
        "Failed to publish the form. Please try again later."
      );

      setOpen(true);
    }
  };


  // ============================================================
  // LOAD EXISTING FORM
  // ============================================================

  useEffect(() => {
    const fetchData = async (id) => {
      const docRef = doc(db, "forms", id);

      try {
        onSnapshot(docRef, (docSnap) => {
          const info = docSnap.data();

          setData(info);


          if (info) {
            setTimerDuration(info.timerDuration);
            setPercentage(info.percentage);
            setEnableTimer(info.enableTimer);

            setIncludeCamera(
              info.includeCamera
            );


            // ==================================================
            // RESTORE LOCATION SETTING
            // ==================================================

            setIncludeLocation(
              info.includeLocation !== undefined
                ? info.includeLocation
                : true
            );


            setShowResult(
              info.showResult !== undefined
                ? info.showResult
                : true
            );


            setRequireName(
              info.requireName !== undefined
                ? info.requireName
                : false
            );


            setSelectedInstructions(
              Array.isArray(
                info.selectedInstructions
              ) &&
              info.selectedInstructions.length > 0

                ? info.selectedInstructions
                    .map((item) =>
                      typeof item === "string"
                        ? item
                        : item?.id
                    )
                    .filter(Boolean)

                : Array.isArray(
                    info.instructions
                  ) &&
                  info.instructions.length > 0

                  ? info.instructions
                      .map((item) =>
                        typeof item === "string"
                          ? item
                          : item?.id
                      )
                      .filter(Boolean)

                  : ["read-carefully"]
            );


            setCustomInstructions(
              info.customInstructions ||
              info.customInstruction ||
              ""
            );
          }
        });

      } catch (error) {
        console.error(
          "Error fetching data:",
          error
        );
      }
    };


    fetchData(id);


    return () => {
      // Firestore listener cleanup
    };
  }, [id]);


  // ============================================================
  // QUESTION FUNCTIONS
  // ============================================================

  function changeQuestion(
    text,
    i,
    targetArray
  ) {
    const newQuestion = [
      ...(
        targetArray === "local"
          ? questions
          : data.questions
      ),
    ];


    newQuestion[i] = {
      ...newQuestion[i],
      questionText: text,
    };


    if (targetArray === "local") {
      setQuestions(newQuestion);

    } else if (targetArray === "firebase") {
      setData({
        ...data,
        questions: newQuestion,
      });
    }
  }


  function addQuestionType(
    i,
    type,
    targetArray
  ) {
    const updateQuestions = (
      prevQuestions
    ) => {
      const newQuestions = [
        ...prevQuestions,
      ];


      if (newQuestions[i]) {
        newQuestions[i] = {
          ...newQuestions[i],
          questionType: type,
          answerKey:
            type === "checkbox"
              ? []
              : "",
        };
      }


      return newQuestions;
    };


    if (targetArray === "local") {
      setQuestions(updateQuestions);

    } else if (
      targetArray === "firebase"
    ) {
      setData((prevData) => ({
        ...prevData,

        questions: updateQuestions(
          prevData.questions || []
        ),
      }));
    }


    setDefaultOption(
      type.charAt(0).toUpperCase() +
      type.slice(1)
    );
  }


  const validateDuplicateOption = (
    text,
    i,
    j,
    targetArray
  ) => {
    if (
      !text ||
      text.trim() === ""
    ) {
      return true;
    }


    const currentQuestions =
      targetArray === "local"
        ? questions || []
        : data?.questions || [];


    const currentQuestion =
      currentQuestions[i];


    if (!currentQuestion) {
      return true;
    }


    const options = Array.isArray(
      currentQuestion.options
    )
      ? currentQuestion.options
      : [];


    const currentText =
      text.trim().toLowerCase();


    const duplicateExists =
      options.some(
        (option, index) => {
          if (index === j) {
            return false;
          }


          const optionText =
            option?.optionText
              ?.trim()
              .toLowerCase();


          return (
            optionText &&
            optionText === currentText
          );
        }
      );


    if (duplicateExists) {
      setDuplicateDialogOpen(true);
      return false;
    }


    return true;
  };


  function changeOptionValue(
    text,
    i,
    j,
    targetArray
  ) {
    const sourceQuestions =
      targetArray === "local"
        ? questions || []
        : data?.questions || [];


    const newQuestions = [
      ...sourceQuestions,
    ];


    if (
      !newQuestions[i] ||
      !Array.isArray(
        newQuestions[i].options
      ) ||
      !newQuestions[i].options[j]
    ) {
      return;
    }


    newQuestions[i] = {
      ...newQuestions[i],

      options:
        newQuestions[i].options.map(
          (option, index) =>
            index === j
              ? {
                  ...option,
                  optionText: text,
                }
              : option
        ),
    };


    if (targetArray === "local") {
      setQuestions(newQuestions);

    } else if (
      targetArray === "firebase"
    ) {
      setData((prevData) => ({
        ...(prevData || {}),
        questions: newQuestions,
      }));
    }
  }


  function handleOptionBlur(
    text,
    i,
    j,
    targetArray
  ) {
    validateDuplicateOption(
      text,
      i,
      j,
      targetArray
    );
  }


  function removeOption(
    i,
    j,
    targetArray
  ) {
    const newQuestions = [
      ...(
        targetArray === "local"
          ? questions
          : data.questions
      ),
    ];


    if (
      newQuestions[i].options.length > 1
    ) {
      newQuestions[i] = {
        ...newQuestions[i],

        options:
          newQuestions[i].options.filter(
            (_, index) =>
              index !== j
          ),
      };


      if (targetArray === "local") {
        setQuestions(newQuestions);

      } else if (
        targetArray === "firebase"
      ) {
        setData({
          ...data,
          questions: newQuestions,
        });
      }
    }
  }


  function addOption(
    i,
    targetArray
  ) {
    const newQuestions = [
      ...(
        targetArray === "local"
          ? questions
          : data.questions
      ),
    ];


    if (
      newQuestions[i].options.length >= 1
    ) {
      newQuestions[i] = {
        ...newQuestions[i],

        options: [
          ...newQuestions[i].options,
          {
            optionText: "",
          },
        ],
      };


      if (targetArray === "local") {
        setQuestions(newQuestions);

      } else if (
        targetArray === "firebase"
      ) {
        setData({
          ...data,
          questions: newQuestions,
        });
      }

    } else {
      console.log("Max 5 options");
    }
  }


  function copyQuestion(
    i,
    targetArray
  ) {
    const newQuestions = [
      ...(
        targetArray === "local"
          ? questions
          : data.questions
      ),
    ];


    const newQuestion =
      newQuestions[i];


    if (targetArray === "local") {
      setQuestions([
        ...newQuestions,
        newQuestion,
      ]);

    } else if (
      targetArray === "firebase"
    ) {
      setData({
        ...data,

        questions: [
          ...data.questions,
          newQuestion,
        ],
      });
    }
  }


  function deleteQuestion(
    i,
    targetArray
  ) {
    const newQuestions = [
      ...(
        targetArray === "local"
          ? questions
          : data.questions
      ),
    ];


    if (newQuestions.length > 1) {
      newQuestions.splice(i, 1);


      if (targetArray === "local") {
        setQuestions(newQuestions);

      } else if (
        targetArray === "firebase"
      ) {
        setData({
          ...data,
          questions: newQuestions,
        });
      }
    }
  }


  const handleDelete = () => {
    const shouldDelete =
      window.confirm(
        "Are you sure you want to delete this question?"
      );


    if (shouldDelete) {
      deleteQuestion(
        i,
        "local"
      );
    }
  };


  function requiredQuestion(
    i,
    targetArray
  ) {
    const newQuestions = [
      ...(
        targetArray === "local"
          ? questions
          : data.questions
      ),
    ];


    newQuestions[i] = {
      ...newQuestions[i],

      required:
        !newQuestions[i].required,
    };


    if (targetArray === "local") {
      setQuestions(newQuestions);

    } else if (
      targetArray === "firebase"
    ) {
      setData({
        ...data,
        questions: newQuestions,
      });
    }
  }


  function addMoreQuestionField(targetArray) {
  const newQuestion = {
    questionText: "",
    questionType: "radio",
    options: [{ optionText: "" }],
    open: true,
    required: false,
    points: 0,
    answerKey: "", // matches questionType: "radio" (string, not array)
  };
  


    if (targetArray === "local") {
      setQuestions(
        (prevQuestions) => [
          ...prevQuestions,
          newQuestion,
        ]
      );

    } else if (
      targetArray === "firebase"
    ) {
      setData(
        (prevData) => ({
          ...prevData,

          questions: [
            ...(prevData.questions || []),
            newQuestion,
          ],
        })
      );
    }
  }


  function setOptionAnswer(
    optionText,
    i,
    source
  ) {
    const newQuestions = [
      ...(
        source === "local"
          ? questions
          : data.questions
      ),
    ];


    const question =
      newQuestions[i];


    if (
      question.questionType ===
      "checkbox"
    ) {
      if (
        !Array.isArray(
          question.answerKey
        )
      ) {
        question.answerKey = [];
      }


      const index =
        question.answerKey.indexOf(
          optionText
        );


      if (index > -1) {
        question.answerKey.splice(
          index,
          1
        );

      } else {
        question.answerKey.push(
          optionText
        );
      }

    } else {
      question.answerKey =
        optionText;
    }


    if (source === "local") {
      setQuestions(
        newQuestions
      );

    } else if (
      source === "firebase"
    ) {
      setData(
        (prevData) => ({
          ...prevData,

          questions:
            newQuestions,
        })
      );
    }


    console.log(
      "Updated question:",
      question
    );

    console.log(
      "Updated answerKey:",
      question.answerKey
    );
  }


  function setOptionPoints(
    points,
    qno,
    source
  ) {
    const newQuestions = [
      ...(
        source === "local"
          ? questions
          : (data &&
              data.questions) ||
            []
      ),
    ];


    if (newQuestions[qno]) {
      const pointValue =
        points === ""
          ? ""
          : parseInt(
              points,
              10
            ) || 0;


      newQuestions[qno] = {
        ...newQuestions[qno],

        points:
          pointValue,
      };

    } else {
      console.error(
        `Question at index ${qno} is undefined`
      );

      return;
    }


    if (source === "local") {
      setQuestions(
        newQuestions
      );

    } else if (
      source === "firebase" &&
      data
    ) {
      setData(
        (prevData) => ({
          ...prevData,

          questions:
            newQuestions,
        })
      );
    }
  }


  function doneAnswer(
    i,
    targetArray
  ) {
    const newQuestions = [
      ...(
        targetArray === "local"
          ? questions
          : data.questions
      ),
    ];


    newQuestions[i].answer =
      !newQuestions[i].answer;


    if (targetArray === "local") {
      setQuestions(
        newQuestions
      );

    } else if (
      targetArray === "firebase"
    ) {
      setData({
        ...data,
        questions:
          newQuestions,
      });
    }


    console.log();
  }


  function addAnswer(
    i,
    targetArray
  ) {
    const newQuestions = [
      ...(
        targetArray === "local"
          ? questions
          : data.questions
      ),
    ];


    newQuestions[i].answer =
      !newQuestions[i].answer;


    if (targetArray === "local") {
      setQuestions(
        newQuestions
      );

    } else if (
      targetArray === "firebase"
    ) {
      setData({
        ...data,
        questions:
          newQuestions,
      });
    }
  }


  // ============================================================
  // INSTRUCTION TOGGLE
  // ============================================================

  const toggleInstruction = (
    instructionId
  ) => {
    setSelectedInstructions(
      (current) =>
        current.includes(
          instructionId
        )
          ? current.filter(
              (id) =>
                id !== instructionId
            )
          : [
              ...current,
              instructionId,
            ]
    );
  };


  // ============================================================
  // QUESTION UI
  // ============================================================

  const questionUI = () => {
    const renderQuestions = (
      questions,
      source
    ) => {
      return questions.map(
        (ques, i) => (
          <Accordion
            key={i}
            expanded={ques.open}
            className={
              ques.open
                ? "add_border"
                : ""
            }
          >
            <div className="question_boxes">

              {true ? (
                <AccordionDetails className="add_question">
                  {ques.questionType !== "text" && !questionHasAnswerKey(ques) && (
  <div className="answer-key-missing-warning">
    
  </div>
)}

                  <div className="add_question_top">


                    <input
                      type="text"
                      className="question"
                      placeholder="Question"
                      value={
                        ques.questionText
                      }
                      onChange={(e) =>
                        changeQuestion(
                          e.target.value,
                          i,
                          source
                        )
                      }
                    />

                    <Select
                      className="select"
                      style={{
                        color:
                          "#5f6368",
                      }}
                      value={
                        ques.questionType
                          .charAt(0)
                          .toUpperCase() +
                        ques.questionType.slice(
                          1
                        )
                      }
                      onChange={(e) =>
                        addQuestionType(
                          i,
                          e.target.value.toLowerCase(),
                          source
                        )
                      }
                    >

                      <MenuItem
                        id="text"
                        value="Text"
                        onClick={() =>
                          addQuestionType(
                            i,
                            "text",
                            source
                          )
                        }
                      >
                        <SubjectIcon
                          style={{
                            marginRight:
                              "10px",
                            color:
                              "#70757a",
                          }}
                        />

                        TextBox
                      </MenuItem>


                      <MenuItem
                        id="checkbox"
                        value="Checkbox"
                        onClick={() =>
                          addQuestionType(
                            i,
                            "checkbox",
                            source
                          )
                        }
                      >
                        <CheckBoxIcon
                          style={{
                            marginRight:
                              "10px",
                            color:
                              "#70757a",
                          }}
                        />

                        CheckBoxes
                      </MenuItem>


                      <MenuItem
                        id="radio"
                        value="Radio"
                        onClick={() =>
                          addQuestionType(
                            i,
                            "radio",
                            source
                          )
                        }
                      >
                        <Radio
                          style={{
                            width:
                              "5px",
                            marginRight:
                              "10px",
                            color:
                              "#70757a",
                          }}
                          checked
                        />

                        Radio Button
                      </MenuItem>

                    </Select>


                    <label className="question-points-control">

                      <span>
                        Weight
                      </span>

                      <input
                        type="number"
                        min="0"
                        step="1"
                        value={
                          ques.points ??
                          0
                        }
                        onFocus={(e) => {
                          if (
                            e.target
                              .value ===
                            "0"
                          ) {
                            setOptionPoints(
                              "",
                              i,
                              source
                            );
                          } else {
                            e.target.select();
                          }
                        }}
                        onBlur={(e) => {
                          if (
                            e.target
                              .value ===
                            ""
                          ) {
                            setOptionPoints(
                              "0",
                              i,
                              source
                            );
                          }
                        }}
                        onChange={(e) =>
                          setOptionPoints(
                            e.target.value,
                            i,
                            source
                          )
                        }
                      />

                    </label>

                  </div>


                  {ques.questionType ===
                  "text" ? (

                    <div className="add_question_body">

                      <input
                        type="text"
                        className="text_input"
                        placeholder="Optional Answer"
                        value={
                          ques.answerKey ||
                          ""
                        }
                        onChange={(e) =>
                          setOptionAnswer(
                            e.target.value,
                            i,
                            source
                          )
                        }
                      />

                    </div>

                  ) : (

                    ques.options.map(
                      (op, j) => (

                        <div
                          className="add_question_body"
                          key={j}
                        >

                          <div
                            style={{
                              display:
                                "flex",
                              alignItems:
                                "center",
                            }}
                          >

                            <div className="form-check">

                              <label
                                style={{
                                  fontSize:
                                    "13px",
                                  display:
                                    "flex",
                                  alignItems:
                                    "center",
                                }}
                              >

                                <input
                                  type={
                                    ques.questionType ===
                                    "checkbox"
                                      ? "checkbox"
                                      : "radio"
                                  }
                                  name={
                                    ques.questionText
                                  }
                                  value={
                                    op.optionText
                                  }
                                  checked={
                                    ques.questionType ===
                                    "checkbox"
                                      ? Array.isArray(
                                          ques.answerKey
                                        ) &&
                                        ques.answerKey.includes(
                                          op.optionText
                                        )
                                      : ques.answerKey ===
                                        op.optionText
                                  }
                                  onChange={() =>
                                    setOptionAnswer(
                                      op.optionText,
                                      i,
                                      source
                                    )
                                  }
                                  className="form-check-input"
                                  required={
                                    ques.required
                                  }
                                  style={{
                                    marginRight:
                                      "10px",
                                    marginBottom:
                                      "10px",
                                    marginTop:
                                      "5px",
                                  }}
                                />


                                <input
                                  type="text"
                                  className="text_input"
                                  placeholder="Option text"
                                  value={
                                    op.optionText
                                  }
                                  onChange={(e) =>
                                    changeOptionValue(
                                      e.target.value,
                                      i,
                                      j,
                                      source
                                    )
                                  }
                                  onBlur={(e) =>
                                    handleOptionBlur(
                                      e.target.value,
                                      i,
                                      j,
                                      source
                                    )
                                  }
                                  style={{
                                    marginLeft:
                                      "10px",
                                    flex: 1,
                                  }}
                                />

                              </label>

                            </div>


                            <IconButton
                              aria-label="delete"
                              onClick={() =>
                                removeOption(
                                  i,
                                  j,
                                  source
                                )
                              }
                              style={{
                                marginLeft:
                                  "10px",
                              }}
                            >
                              <CloseIcon />
                            </IconButton>

                          </div>

                        </div>
                      )
                    )

                  )}


                  {ques.questionType !==
                  "text" ? (

                    <div className="add_question_body">

                      <div>

                        <IconButton
                          size="small"
                          onClick={() =>
                            addOption(
                              i,
                              source
                            )
                          }
                          style={{
                            textTransform:
                              "none",
                            fontSize:
                              "13px",
                          }}
                        >
                          <AddIcon />
                        </IconButton>

                      </div>

                    </div>

                  ) : (
                    ""
                  )}


                  <div className="add_footer">

                    <div className="add_question_bottom_left">
                      {ques.questionType === "text" ? (
                        <span className="text-box-notice">
                          ℹ️ Text box questions cannot be auto-graded. Form results will be disabled.
                        </span>
                      ) : (
                        <span className="inline-answer-hint">
                          Select the correct answer beside each option
                        </span>
                      )}
                    </div>


                    <div className="add_question_bottom">

                      <IconButton
                        aria-label="copy"
                        onClick={() =>
                          copyQuestion(
                            i,
                            source
                          )
                        }
                      >
                        <FilterNoneIcon />
                      </IconButton>


                      <IconButton
                        aria-label="delete"
                        onClick={() =>
                          deleteQuestion(
                            i,
                            source
                          )
                        }
                      >
                        <BsTrash />
                      </IconButton>


                      <span
                        style={{
                          color:
                            "#5f6368",
                          fontSize:
                            "13px",
                          fontFamily:
                            "Arial",
                        }}
                      >
                        Required
                      </span>


                      <Switch
                        name="checkedA"
                        color="primary"
                        onClick={() =>
                          requiredQuestion(
                            i,
                            source
                          )
                        }
                        checked={
                          ques.required
                        }
                      />

                    </div>

                  </div>

                </AccordionDetails>

              ) : (

                <AccordionDetails className="add_answer_key">

                  <div className="top_header">
                    Choose Correct Answer
                  </div>


                  <div
                    className="add_question_top"
                    style={{
                      marginLeft:
                        "8px",
                      marginBottom:
                        "10px",
                      marginTop:
                        "5px",
                    }}
                  >

                    <input
                      type="text"
                      className="question"
                      placeholder="Question"
                      value={
                        ques.questionText
                      }
                      disabled
                    />


                    <div
                      style={{
                        display:
                          "flex",
                        alignItems:
                          "center",
                        gap:
                          "8px",
                      }}
                    >

                      <input
                        type="number"
                        className="points"
                        min="0"
                        step="1"
                        value={
                          ques.points ??
                          0
                        }
                        onFocus={(e) => {
                          if (
                            e.target
                              .value ===
                            "0"
                          ) {
                            setOptionPoints(
                              "",
                              i,
                              source
                            );
                          } else {
                            e.target.select();
                          }
                        }}
                        onBlur={(e) => {
                          if (
                            e.target
                              .value ===
                            ""
                          ) {
                            setOptionPoints(
                              "0",
                              i,
                              source
                            );
                          }
                        }}
                        onChange={(e) =>
                          setOptionPoints(
                            e.target.value,
                            i,
                            source
                          )
                        }
                      />


                      <span
                        style={{
                          fontSize:
                            "11px",
                          color:
                            "#5f6368",
                          marginTop:
                            "4px",
                          whiteSpace:
                            "nowrap",
                        }}
                      >
                        Weight
                      </span>

                    </div>

                  </div>


                  {ques.questionType ===
                  "text" ? (

                    <div
                      className="add_question_body"
                      style={{
                        marginLeft:
                          "8px",
                      }}
                    >

                      <ShortTextIcon
                        style={{
                          marginRight:
                            "10px",
                        }}
                      />

                      <input
                        type="text"
                        className="text_input"
                        placeholder="Enter correct answer"
                        value={
                          ques.answerKey
                        }
                        onChange={(e) =>
                          setOptionAnswer(
                            e.target.value,
                            i,
                            source
                          )
                        }
                        style={{
                          width:
                            "100%",
                        }}
                      />

                    </div>

                  ) : (

                    ques.options.map(
                      (op, j) => (

                        <div
                          className="add_question_body"
                          key={j}
                          style={{
                            marginBottom:
                              "10px",
                            marginTop:
                              "5px",
                            marginLeft:
                              "8px",
                          }}
                        >

                          <div key={j}>

                            <div
                              style={{
                                display:
                                  "flex",
                              }}
                            >

                              <div className="form-check">

                                <label
                                  style={{
                                    fontSize:
                                      "13px",
                                  }}
                                  onClick={() =>
                                    setOptionAnswer(
                                      op.optionText,
                                      i,
                                      source
                                    )
                                  }
                                >

                                  <input
                                    type={
                                      ques.questionType
                                    }
                                    name={
                                      ques.questionText
                                    }
                                    value="option3"
                                    className="form-check-input"
                                    required={
                                      ques.required
                                    }
                                    style={{
                                      marginRight:
                                        "10px ",
                                      marginBottom:
                                        "10px",
                                      marginTop:
                                        "5px",
                                    }}
                                  />

                                  {op.optionText}

                                </label>

                              </div>

                            </div>

                          </div>

                        </div>

                      )
                    )

                  )}


                  <div className="add_question_bottom">

                    <Button
                      style={{
                        textTransform:
                          "none",
                        color:
                          "4285f4",
                        fontSize:
                          "12px",
                        marginTop:
                          "12px",
                        fontWeight:
                          "600",
                      }}
                      variant="outlined"
                      color="primary"
                      onClick={() =>
                        doneAnswer(
                          i,
                          source
                        )
                      }
                    >
                      Save
                    </Button>

                  </div>

                </AccordionDetails>

              )}

            </div>
          </Accordion>
        )
      );
    };


    if (
      data &&
      Array.isArray(
        data.questions
      )
    ) {
      return renderQuestions(
        data.questions,
        "firebase"
      );

    } else if (
      Array.isArray(
        questions
      )
    ) {
      return renderQuestions(
        questions,
        "local"
      );

    } else {
      console.error(
        "Data or questions array is not defined or not an array"
      );

      return null;
    }
  };


  // ============================================================
  // RETURN / UI
  // ============================================================

  return (
    <div className="form-builder-page">

      {/* ======================================================
          SHARE DIALOG
      ====================================================== */}

      <Dialog
        open={shareDialogOpen}
        onClose={() =>
          setShareDialogOpen(false)
        }
        maxWidth="sm"
        fullWidth
      >

        <DialogTitle
          sx={{
            fontSize:
              "21px",
            fontWeight:
              600,
            color:
              "#202124",
            pb: 1,
          }}
        >
          Test published successfully
        </DialogTitle>


        <DialogContent>

          <Typography
            sx={{
              color:
                "#5f6368",
              fontSize:
                "14px",
              mb: 2,
            }}
          >
            Share this link with candidates to let them open the test.
          </Typography>


          <div
            style={{
              display:
                "flex",
              alignItems:
                "center",
              gap:
                "8px",
              padding:
                "10px 12px",
              border:
                "1px solid #dadce0",
              borderRadius:
                "6px",
              background:
                "#f8f9fa",
            }}
          >

            <input
              type="text"
              value={
                publishedFormUrl
              }
              readOnly
              onFocus={(e) =>
                e.target.select()
              }
              style={{
                flex: 1,
                minWidth: 0,
                border:
                  "none",
                outline:
                  "none",
                background:
                  "transparent",
                color:
                  "#3c4043",
                fontSize:
                  "13px",
              }}
            />


            <Button
              variant="contained"
              onClick={async () => {
                try {
                  await navigator.clipboard.writeText(
                    publishedFormUrl
                  );

                  setColor(
                    "success"
                  );

                  setText(
                    "Test link copied to clipboard."
                  );

                  setOpen(
                    true
                  );

                } catch (error) {
                  console.error(
                    "Unable to copy test link:",
                    error
                  );

                  setColor(
                    "error"
                  );

                  setText(
                    "Unable to copy the link. Please copy it manually."
                  );

                  setOpen(
                    true
                  );
                }
              }}
              style={{
                backgroundColor:
                  "#673ab7",
                color:
                  "#fff",
                textTransform:
                  "none",
                fontWeight:
                  600,
                whiteSpace:
                  "nowrap",
              }}
            >
              COPY
            </Button>

          </div>

        </DialogContent>


        <DialogActions
          sx={{
            px: 3,
            pb: 2,
          }}
        >

          <Button
            onClick={() =>
              setShareDialogOpen(
                false
              )
            }
            sx={{
              color:
                "#673ab7",
              fontWeight:
                600,
              textTransform:
                "none",
            }}
          >
            Done
          </Button>

        </DialogActions>

      </Dialog>


      {/* ======================================================
          DUPLICATE OPTION DIALOG
      ====================================================== */}

      <Dialog
        open={
          duplicateDialogOpen
        }
        onClose={() =>
          setDuplicateDialogOpen(
            false
          )
        }
        maxWidth="xs"
        fullWidth
      >

        <DialogTitle
          sx={{
            fontSize:
              "20px",
            fontWeight:
              500,
            color:
              "#202124",
            pb: 1,
          }}
        >
          Duplicate option
        </DialogTitle>


        <DialogContent>

          <Typography
            sx={{
              color:
                "#5f6368",
              fontSize:
                "14px",
              lineHeight:
                1.6,
            }}
          >
            This option already exists in this question. Please enter a different option.
          </Typography>

        </DialogContent>


        <DialogActions
          sx={{
            px: 2,
            pb: 2,
          }}
        >

          <Button
            onClick={() =>
              setDuplicateDialogOpen(
                false
              )
            }
            sx={{
              color:
                "#673ab7",
              fontWeight:
                600,
              textTransform:
                "none",

              "&:hover": {
                backgroundColor:
                  "#f3eefa",
              },
            }}
          >
            OK
          </Button>

        </DialogActions>

      </Dialog>


      {/* ======================================================
          PAGE HEADER
      ====================================================== */}

      <DashboardSidebar
        activePage="Forms"
      />

      <Formheader
        photoURL={
          photoURL
        }
        value={
          value
        }
        formName={
          data
            ? data.formName
            : formName
        }
      />

      <Centeredtab isPublished={Boolean(data?.activate || publishedFormUrl)} />


      <SnackBar
        open={
          open
        }
        handleClose={
          handleClose
        }
        text={
          text
        }
        color={
          color
        }
      />


      {/* ======================================================
          FORM
      ====================================================== */}

      <div className="question_form">

        <br />

        <div className="section">


          {/* ==================================================
              FORM NAME + DESCRIPTION
          ================================================== */}

          <div className="question_title_section">

            <div className="question_form_top">

              <input
                type="text"
                placeholder="Form Name"
                style={{
                  color:
                    "black",
                }}
                className="question_form_top_name"
                value={
                  data
                    ? data.formName
                    : formName
                }
                onChange={(e) =>
                  data
                    ? setData((previousData) => ({
                        ...previousData,
                        formName: e.target.value,
                      }))
                    : setFormName(e.target.value)
                }
                required
              />


              <input
                type="text"
                placeholder="Form Description"
                className="question_form_top_desc"
                value={
                  data
                    ? data.formDescription
                    : formDescription
                }
                onChange={(e) =>
                  data
                    ? setData((previousData) => ({
                        ...previousData,
                        formDescription: e.target.value,
                      }))
                    : setFormDescription(e.target.value)
                }
                required
              />

            </div>

          </div>


          {/* QUESTIONS */}

          {questionUI()}


          {/* ==================================================
              ADD QUESTION
          ================================================== */}

          <div className="add-question-area">

            <button
              type="button"
              className="add-question-button"
              onClick={() =>
                addMoreQuestionField(
                  data
                    ? "firebase"
                    : "local"
                )
              }
              title="Add new question"
            >

              <span className="add-question-icon">
                +
              </span>

              <span>
                <strong>
                  Add question
                </strong>

                <small>
                  Create another question
                </small>
              </span>

            </button>

          </div>


          {/* ==================================================
              TEST INSTRUCTIONS
          ================================================== */}

          <div className="instructions-builder-card">

            <div className="instructions-builder-header">

              <div>

                <div className="instructions-builder-title">
                  Test instructions
                </div>

                <div className="instructions-builder-subtitle">
                  Choose what candidates should see before they start this test.
                </div>

              </div>

            </div>


            <div className="instruction-choice-list">

              {instructionOptions.map(
                (instruction) => (

                  <label
                    key={
                      instruction.id
                    }
                    className={`instruction-choice ${
                      selectedInstructions.includes(
                        instruction.id
                      )
                        ? "instruction-choice-selected"
                        : ""
                    }`}
                  >

                    <input
                      type="checkbox"
                      checked={selectedInstructions.includes(
                        instruction.id
                      )}
                      onChange={() =>
                        toggleInstruction(
                          instruction.id
                        )
                      }
                    />


                    <span className="instruction-choice-check">

                      {selectedInstructions.includes(
                        instruction.id
                      )
                        ? "✓"
                        : ""}

                    </span>


                    <span className="instruction-choice-content">

                      <strong>
                        {
                          instruction.title
                        }
                      </strong>

                      <small>
                        {
                          instruction.text
                        }
                      </small>

                    </span>

                  </label>

                )
              )}

            </div>


            <div className="custom-instruction">

              <label
                htmlFor="custom-instruction"
              >
                Custom instruction{" "}
                <span>
                  (optional)
                </span>
              </label>


              <textarea
                id="custom-instruction"
                value={
                  customInstructions
                }
                onChange={(e) =>
                  setCustomInstructions(
                    e.target.value
                  )
                }
                placeholder="Add any additional instruction you want candidates to see..."
                rows={3}
              />

            </div>


            <div className="instruction-note">
              Selected instructions will be shown to candidates on the page they see before starting the test.
            </div>

          </div>


          {/* ==================================================
              TEST SETTINGS
          ================================================== */}

          <div className="settings-builder-card">

            <div className="instructions-builder-header">

              <div>

                <div className="instructions-builder-title">
                  Test settings
                </div>

                <div className="instructions-builder-subtitle">
                  Fine-tune how candidates take and submit this test.
                </div>

              </div>

            </div>

            {((data?.questions || questions) || []).some(
              (q) => q.questionType === "text"
            ) && (
              <div className="text-box-settings-warning">
                ℹ️ <strong>Automated results disabled:</strong> This form contains Text Box questions. Scoring and automated results will be disabled for this form.
              </div>
            )}

            <div className="toggle-grid">


              {/* MULTIPLE RESPONSES */}

              <ToggleRow
                icon={
                  <BsPeople />
                }
                label="Multiple responses"
                description="Allow more than one submission"
                checked={
                  isAnonymous
                }
                onChange={
                  handleSwitchChange
                }
              />


              {/* CAMERA */}

              <ToggleRow
                icon={
                  <BsCameraVideo />
                }
                label="Camera"
                description="Require camera access"
                checked={
                  includeCamera
                }
                onChange={
                  handleCameraToggle
                }
              />


              {/* =================================================
                  LOCATION - LIFTED FROM SECOND CODE
              ================================================= */}

              <ToggleRow
                icon={
                  <BsGeoAlt />
                }
                label="Location"
                description="Ask for location access"
                checked={
                  includeLocation
                }
                onChange={
                  handleLocationToggle
                }
              />


              {/* SHOW RESULT */}

              <ToggleRow
                icon={
                  <BsEye />
                }
                label="Show result"
                description="Reveal score after submission"
                checked={
                  showResult
                }
                onChange={(e) =>
                  setShowResult(
                    e.target.checked
                  )
                }
              />


              


              {/* TIMER */}

              <ToggleRow
                icon={
                  <BsClock />
                }
                label="Timer"
                description="Limit how long candidates have"
                checked={
                  enableTimer
                }
                onChange={
                  handleSwitchChange1
                }
              />
              {/* REQUIRE NAME */}

              <ToggleRow
                icon={
                  <BsPersonBadge />
                }
                label="Require name"
                description="Ask name, email & phone first"
                checked={
                  requireName
                }
                onChange={(e) =>
                  setRequireName(
                    e.target.checked
                  )
                }
              />

            </div>


            {/* TIMER DURATION */}

            {enableTimer && (

              <div className="timer-duration-row">

                <input
                  type="number"
                  value={
                    timerDuration
                  }
                  placeholder="Timer Duration"
                  onChange={(e) => {
                    const value = e.target.value;
                    setTimerDuration(value);
                    setData((previousData) => ({
                      ...previousData,
                      timerDuration: value,
                    }));
                  }}
                />

                <span>
                  (in mins)
                </span>

              </div>

            )}

          </div>


          {/* ==================================================
              PERCENTAGE
          ================================================== */}

          <div className="percentage-setting">

            <label
              htmlFor="percentage"
            >
              Assessment passing percent if any :
            </label>


            <input
              id="percentage"
              type="number"
              value={
                percentage
              }
              placeholder="Percentage Criteria"
              onChange={(e) =>
                setPercentage(
                  e.target.value
                )
              }
            />

          </div>


          {/* ==================================================
              FORM ACTIONS
          ================================================== */}

          <div
            className="form-actions-row"
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
              flexWrap: "wrap",
              gap: "16px",
            }}
          >

            <div
              className="form-actions-row-buttons"
              style={{
                display: "flex",
                alignItems: "center",
                gap: "16px",
              }}
            >


              {/* SAVE DRAFT */}

              <Button
                variant="contained"
                className="save-draft-button"
                onClick={async () => {

                  if (
                    await formExistsInDatabase(
                      id
                    )
                  ) {

                    handleSaveAsDraft();

                  } else if (
                    formName &&
                    formDescription
                  ) {

                    handleSaveAsDraft();

                  } else {

                    setColor(
                      "error"
                    );

                    setOpen(
                      true
                    );

                    setText(
                      "Form name and form description are required fields."
                    );
                  }

                }}
              >
                Save as Draft
              </Button>


              {/* PUBLISH */}

              <Button
                variant="contained"
                className="send-form-button"
                onClick={() => {

                  if (
                    (
                      data
                        ? data.formName
                        : formName
                    ) &&
                    (
                      data
                        ? data.formDescription
                        : formDescription
                    )
                  ) {

                    handleSendForm();

                  } else {

                    setColor(
                      "error"
                    );

                    setOpen(
                      true
                    );

                    setText(
                      "Form name and form description are required fields."
                    );

                  }

                }}
              >
                Publish
              </Button>


              {/* SHARE ICON — appears right after the buttons, only once published */}

              {publishedFormUrl && (

                <Tooltip title="Share test">
                  <IconButton
                    aria-label="share test"
                    className="share-test-trigger-icon"
                    onClick={() =>
                      setShareDialogOpen(true)
                    }
                    style={{
                      marginLeft: "8px",
                      backgroundColor: "#f3eefa",
                      color: "#673ab7",
                    }}
                  >
                    <ShareIcon fontSize="small" />
                  </IconButton>
                </Tooltip>

              )}

            </div>

          </div>

        </div>

      </div>

    </div>
  );
}


export default QuestionForm;